import { useEffect, useRef, useState } from "react";
import { connectNotifications } from "@/socket";

export type NotificationPayload = any;

export function useNotifications(token: string | null) {
  const createdRef = useRef(false);
  const [last, setLast] = useState<NotificationPayload | null>(null);
  const [feed, setFeed] = useState<NotificationPayload[]>([]);

  useEffect(() => {
    if (!token) return;
    if (createdRef.current) return;

    const socket = connectNotifications(token);
    createdRef.current = true;

    const onNotification = (data: NotificationPayload) => {
      setLast(data);
      setFeed((prev) => [data, ...prev]);
    };

    const onConnect = () => console.log("WS connected:", socket.id);
    const onAuth = (p: any) => console.log("WS authenticated:", p);
    const onDisconnect = (r: string) => console.log("WS disconnected:", r);
    const onErr = (e: any) => console.warn("WS error:", e);

    socket.on("connect", onConnect);
    socket.on("authenticated", onAuth);
    socket.on("notification", onNotification);
    socket.on("disconnect", onDisconnect);
    socket.on("error", onErr);
    socket.on("connect_error", (err) => console.warn("WS connect_error:", err?.message));
    return () => {
      socket.off("connect", onConnect);
      socket.off("authenticated", onAuth);
      socket.off("notification", onNotification);
      socket.off("disconnect", onDisconnect);
      socket.off("error", onErr);
      createdRef.current = false;
    };
  }, [token]);

  return { last, feed };
}
